const _maps = {
    opening: 'Đang mở',
    closed: 'Đã đóng',
    deleted: 'Đã xóa',
    shipped: 'Đã gửi hàng',
}

export default (status) => {
    return _maps[status] || status
}
